export const WorkoutSummary = ({ workout }) => {

    return (


        workout?.map((exercise, index) => (
            <div className="d-flex justify-content-between small" key={index}>
                {exercise?.exerciseName}
                <div>
                    <span>{exercise?.result}</span>
                    <span>x</span>
                    <span>{exercise?.repetitions}</span>
                </div>
            </div>
        ))



    )
}